import { createFileRoute } from "@tanstack/react-router";
import { TelusEnrollPage } from "@pages/telus-enroll-page";

export const Route = createFileRoute("/telus/register/enroll")({
  component: TelusEnrollPage,
});
